(() => {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    // ==========================================================================
    // Gsap
    // ==========================================================================
    // 任意の子要素のクラスをここで指定（例: .fade-item）
    const topSectionAnimeSelector = ".js-top-section-anime";
    const topSectionAnimeCardSelector = ".js-top-section-anime-card > div";
    const topSectionAnimeLineSelector = ".js-top-section-anime-heading .-line";
    const topSectionAnimeTextSelector = ".js-top-section-anime-heading .-text";
    const topSectionAnimeBgSelector = ".js-top-section-anime-bg";
    const topSectionAnimeFigureSelector = ".js-top-section-anime-figure";

    // set background image from picture (pc srcset / sp src)
    const mq = window.matchMedia("(min-width: 768px)");
    const updateBgFromPicture = function () {
      document.querySelectorAll(".js-top-section-anime").forEach(function (sec) {
        const bg = sec.querySelector(".js-top-section-anime-bg");
        const pic = sec.querySelector(".js-top-section-anime-figure picture");
        if (!bg || !pic) return;
        const pc = pic
          .querySelector('source[media="(min-width: 768px)"]')
          ?.getAttribute("srcset");
        const sp = pic.querySelector("img")?.getAttribute("src");
        const url = mq.matches ? (pc || sp) : (sp || pc);
        if (url) bg.style.backgroundImage = "url(" + url + ")";
      });
    };
    updateBgFromPicture();
    (mq.addEventListener
      ? mq.addEventListener("change", updateBgFromPicture)
      : mq.addListener(updateBgFromPicture));

    gsap.utils.toArray(topSectionAnimeSelector).forEach((trigger) => {
      const cardGroup = trigger.querySelectorAll(topSectionAnimeCardSelector);
      const lineGroup = trigger.querySelectorAll(topSectionAnimeLineSelector);
      const textGroup = trigger.querySelectorAll(topSectionAnimeTextSelector);
      const bgGroup = trigger.querySelectorAll(topSectionAnimeBgSelector);
      const figureGroup = trigger.querySelectorAll(topSectionAnimeFigureSelector);

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: trigger,
          start: "top 80%",
          end: "bottom top",
          // end: "bottom bottom",
          // scrub: true,
          // markers: true,
        },
      });

      // 見出し
      if (lineGroup.length) {
        tl.fromTo(
          lineGroup,
          {
            width: "0%",
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 100%)",
          },
          {
            width: "100%",
            duration: 0.8,
            stagger: { each: 0.2 },
            ease: "power4.out",
          },
          0.5
        );

        tl.to(
          textGroup,
          {
            autoAlpha: 1,
            duration: 0,
          },
          "1+=0.6" // ← もしくは ">" の代わりにタイミング明示
        );

        tl.to(
          lineGroup,
          {
            clipPath: "polygon(100% 0, 100% 0, 100% 100%, 100% 100%)",
            duration: 0.6,
            stagger: { each: 0.2 },
            ease: "power4.out",
          },
          ">"
        );
      }

      // カード
      if (cardGroup.length) {
        tl.fromTo(
          cardGroup,
          {
            autoAlpha: 0,
            y: 100,
          },
          {
            autoAlpha: 1,
            y: 0,
            duration: 1,
            stagger: { each: 0.1 },
            ease: "Linear.easeNone",
          },
          0.5
        );
      }

      // 画像
      if (bgGroup.length) {
        tl.fromTo(
          bgGroup,
          {
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
          },
          {
            clipPath: "polygon(100% 0, 100% 0, 100% 100%, 100% 100%)",
            duration: 3,
            ease: "power4.out",
          },
          1.7
        );

        tl.to(
          figureGroup,
          {
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            duration: 3,
            ease: "power4.out",
          },
          "<"
        );
      }
    });
  });
})();
